import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../util/api";

export const buscarTotalContaFinanceira = createAsyncThunk("/PainelGeral/BuscarTotalContaFinanceira", async (idEmpresa: number | null) => {
  try {
    const data = await api.get("/PainelGeral/BuscarTotalContaFinanceira", {
      params: { idEmpresa: idEmpresa },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarTotalContaAuditoria = createAsyncThunk("/PainelGeral/BuscarTotalContaAuditoria", async () => {
  try {
    const data = await api.get("/PainelGeral/BuscarTotalContaAuditoria");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarTotalComprovanteConsignatario = createAsyncThunk("/PainelGeral/BuscarTotalComprovanteConsignatario", async (idEmpresa: number | null) => {
  try {
    const data = await api.get("/PainelGeral/BuscarTotalComprovanteConsignatario", {
      params: { idEmpresa: idEmpresa },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarTotalContabilidade = createAsyncThunk("/PainelGeral/BuscarTotalContabilidade", async () => {
  try {
    const data = await api.get("/PainelGeral/BuscarTotalContabilidade");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarTotalCadastro = createAsyncThunk("/PainelGeral/BuscarTotalCadastro", async () => {
  try {
    const data = await api.get("/PainelGeral/BuscarTotalCadastro");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});
